module.exports = __webpack_public_path__ + "b87036c48d57066901ea1acd13214823.png";